import request from '@/utils/request'

let AppSettingApi = {
  /*小程序*/
  appwxDetail(data) {
    return request._get('/shop/appsetting.appwx/index', data);
  },
  /*小程序*/
  editAppWx(data) {
    return request._post('/shop/appsetting.appwx/index', data);
  },
  /*公众号*/
  appmpDetail(data) {
    return request._get('/shop/appsetting.appmp/index', data);
  },
  /*公众号*/
  editAppMp(data) {
    return request._post('/shop/appsetting.appmp/index', data);
  },
  /*app*/
  appDetail(data) {
    return request._get('/shop/appsetting.app/index', data);
  },
  /*app*/
  editApp(data) {
    return request._post('/shop/appsetting.app/index', data);
  },
}

export default AppSettingApi;



// WEBPACK FOOTER //
// ./src/api/appsetting.js